let TWITCH_SECRET: string = "hbikzhz7ewk9lk64xj5k2m6ykvwvs1";
let TWITCH_CLIENT_ID: string = "kerasbuo4jy6nay3pxdjhpr2nnowdt";
let REDIRECT_URI: string = "https://glip.gg/twitch-success-login";

const TWITCH_OAUTH_URL = `https://id.twitch.tv/oauth2/authorize?client_id=${TWITCH_CLIENT_ID}&redirect_uri=${REDIRECT_URI}&response_type=code&scope=user:read:email+chat:edit+chat:read`;

let YOUTUBE_CLIENT_ID = "373196446500-ojt3ko1ghis9pritfhhogohlotut2hv6.apps.googleusercontent.com";
let YOUTUBE_SECRET = "GIQcKw1-dKecHNdrZLLQWY-Q";
let YOUTUBE_REDIRECT_URI: string = "https://glip.gg/youtube-success-login";

/* const YOUTUBE_OAUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${YOUTUBE_CLIENT_ID}&redirect_uri=${YOUTUBE_REDIRECT_URI}&response_type=code&include_granted_scopes=true&scope=https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email&access_type=offline&prompt=consent`; */

const YOUTUBE_OAUTH_URL = `https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/userinfo.profile+https://www.googleapis.com/auth/userinfo.email&response_type=code&redirect_uri=${YOUTUBE_REDIRECT_URI}&client_id=373196446500-ojt3ko1ghis9pritfhhogohlotut2hv6.apps.googleusercontent.com&access_type=offline`


const YOUTUBE_CHAT_MANAGER_CLIENT_ID = `1024976282178-tv00u6vclgeds0cak5ogvirkub5cjrlc.apps.googleusercontent.com`;
let YOUTUBE_CHAT_MANAGER_REDIRECT_URI: string = "https://glip.gg/youtube-chat-bot-manager";

const YOUTUBE_OAUTH_URL_CHATBOT_MANAGER = `https://accounts.google.com/o/oauth2/v2/auth?scope=https://www.googleapis.com/auth/userinfo.profile+https://www.googleapis.com/auth/userinfo.email+https://www.googleapis.com/auth/youtube+https://www.googleapis.com/auth/youtube.force-ssl&response_type=code&redirect_uri=${YOUTUBE_CHAT_MANAGER_REDIRECT_URI}&client_id=${YOUTUBE_CHAT_MANAGER_CLIENT_ID}&access_type=offline&prompt=consent`

export {
    TWITCH_OAUTH_URL, TWITCH_CLIENT_ID,
    REDIRECT_URI, TWITCH_SECRET,
    YOUTUBE_OAUTH_URL,
    YOUTUBE_OAUTH_URL_CHATBOT_MANAGER
};
